/* The CCPA opt-out mark.
 *
 * California's regulations require this icon to accompany the "Your Privacy Choices" wording —
 * the label without it is not the compliant control. iubenda used to supply it inside the
 * widget it injected into <body>; we render the links ourselves now (see GlobalFooter), so the
 * icon has to come with them. The mark is specified by the regulator, not iubenda's artwork.
 *
 * Inline rather than a file: it is ~400 bytes, it must never 404, and a network request for a
 * compliance mark is a compliance risk.
 *
 * aria-hidden because the adjacent text already names the control; announcing "CCPA Opt-Out
 * Icon" after "Your Privacy Choices" is noise, not information.
 */
const CcpaOptOutIcon = ({ height = 14 }) => (
  <svg width={height * (40 / 18)} height={height} viewBox="0 0 40 18" fill="none"
       xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
       style={{ verticalAlign: 'middle', flexShrink: 0 }}>
    <rect x="0.5" y="0.5" width="39" height="17" rx="8.5" fill="#fff" stroke="#2569F6" />
    <path d="M22.5 0H31C35.9706 0 40 4.02944 40 9C40 13.9706 35.9706 18 31 18H18L22.5 0Z" fill="#2569F6" />
    <path d="M8 9.5L10.5 12L16.5 6" stroke="#2569F6" strokeWidth="1.5"
          strokeLinecap="round" strokeLinejoin="round" />
    <path d="M25.5 6L31.5 12" stroke="#fff" strokeWidth="1.5"
          strokeLinecap="round" strokeLinejoin="round" />
    <path d="M31.5 6L25.5 12" stroke="#fff" strokeWidth="1.5"
          strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CcpaOptOutIcon;
